<script>
	import { syncWithStaging } from '../api';
	let targetClient = null,
		resp = '';
	async function submitForm() {
		resp = await syncWithStaging(targetClient);
		targetClient = null;
	}
</script>

<form on:submit|preventDefault={submitForm}>
	<h3>Sync client configs from staging</h3>
	<input placeholder="Client ID" required id="id" name="id" type="text" bind:value={targetClient} />
	<button class="primary" disabled={!targetClient}>Sync client</button>
	<p>{resp ? resp : ''}</p>
</form>

<style>
	form {
		display: inline-block;
		padding: 1em;
		margin: 1em 0;
		border-radius: 12px;
		border: 1px solid #000;
	}
	input {
		display: block;
		padding: 0.5em 1em;
		margin: 0.5em 0;
	}
	button {
		white-space: nowrap;
	}
	input,
	button {
		width: 100%;
	}
</style>
